import { render, staticRenderFns } from "./OfferTemplates.vue?vue&type=template&id=1f6f8d94"
import script from "./OfferTemplates.vue?vue&type=script&lang=js"
export * from "./OfferTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports